import { useAppDispatch, useAppSelector } from '@src/core/hooks';
import {
  signup,
  editUser,
  sendResetPasswordCode,
  setErrors,
  errorsSelector,
  hasEmailUniquenessErrorSelector,
  pendingSignupSelector,
} from '@src/features/customers/auth/store/auth';
import type { SignupRequest, UserRequest } from '@src/core/buyerApiClient';
import { AUTH_MODE } from '@src/domains/customers';

interface ValidationPayload {
  [key: string]: string[];
}

export function useSignup() {
  const dispatch = useAppDispatch();
  const errors = useAppSelector(errorsSelector)[AUTH_MODE.SIGNUP];
  const hasEmailUniquenessError = useAppSelector(hasEmailUniquenessErrorSelector);
  const pendingSignup = useAppSelector(pendingSignupSelector);

  const createAccount = (payload: SignupRequest) => dispatch(signup(payload));
  const updateAccount = (payload: UserRequest) => dispatch(editUser(payload));
  const triggerPasswordRecovery = (email: string) => dispatch(sendResetPasswordCode({ email }));
  const clearErrors = () => dispatch(setErrors(AUTH_MODE.SIGNUP, {}));
  const setFieldErrors = (payload: ValidationPayload) => dispatch(setErrors(AUTH_MODE.SIGNUP, payload));

  return {
    createAccount,
    updateAccount,
    triggerPasswordRecovery,
    clearErrors,
    setFieldErrors,
    errors,
    hasEmailUniquenessError,
    pendingSignup,
  };
}
